import DealerProductListPanel from "./dealerProductListPanel.container"

export default DealerProductListPanel
